import React from 'react'
import PropTypes from 'prop-types'
import './Characters.styles.css'

/**
 * Hero del shinobi principal (o CTA si no hay).
 */
export default function MainCharacterHero({ character, onEnter, onCreate }) {
  if (!character) {
    return (
      <section className="mainHero mainHero--empty" aria-label="Sin shinobi principal">
        <div className="mainHero__body">
          <p className="mainHero__eyebrow">Dojo</p>
          <h2 className="mainHero__title">Aún no tienes shinobi principal</h2>
          <p className="mainHero__sub">
            Crea un personaje o marca uno como principal con el sello de la tarjeta.
          </p>
          <div className="mainHero__actions">
            <button type="button" className="mainHero__cta" onClick={onCreate}>
              Crear shinobi
            </button>
          </div>
        </div>
      </section>
    )
  }

  const clan = String(character.clan || '').trim()
  const name = String(character.name || '').trim()
  const fullName = clan ? `${clan} ${name}` : name || 'Sin nombre'
  const level = Number(character.level || 1)
  const rank = String(character.rank || '').trim() || 'Genin'
  const imageUrl = character.imageUrl || `/assets/images/${character.slug}.png`

  const handleImgError = (e) => {
    e.currentTarget.src = '/assets/images/shuriken.png'
  }

  return (
    <section className="mainHero" aria-label={`Principal: ${fullName}`}>
      <div className="mainHero__portrait-wrap">
        <img
          className="mainHero__portrait"
          src={imageUrl}
          alt=""
          onError={handleImgError}
        />
      </div>
      <div className="mainHero__body">
        <p className="mainHero__eyebrow">Shinobi principal</p>
        <h2 className="mainHero__title">{fullName}</h2>
        <p className="mainHero__meta">
          <span>Nv. {level}</span>
          <span className="mainHero__dot" aria-hidden="true">
            ·
          </span>
          <span>{rank}</span>
        </p>
        <div className="mainHero__actions">
          <button type="button" className="mainHero__cta" onClick={() => onEnter(character.slug)}>
            Ver ficha
          </button>
        </div>
      </div>
    </section>
  )
}

MainCharacterHero.propTypes = {
  character: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string,
    clan: PropTypes.string,
    rank: PropTypes.string,
    level: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imageUrl: PropTypes.string,
  }),
  onEnter: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
}
